'use client';

import { createContext } from 'react';

export interface StatsigExperimentFlags {
    isSearchHistoryEnabled?: boolean;
    showConversationalSearchCta?: boolean;
    showConversationalSearchAudio?: boolean;
    conversationalAnimatedToggleEnabled?: boolean;
    /** Members get auto-on-hover; visitors keep the mount-time glow instead. */
    autoOnHoverEnabled?: boolean;
}

export const StatsigExperimentContext = createContext<StatsigExperimentFlags>({});
